import { render, staticRenderFns } from "./BuscarPedidoUnidadeCargaTrechoFilterBar.vue?vue&type=template&id=9ace16dc"
import script from "./BuscarPedidoUnidadeCargaTrechoFilterBar.vue?vue&type=script&lang=js"
export * from "./BuscarPedidoUnidadeCargaTrechoFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports